// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602260803/js/" + chunkId + "." + {"44":"1e3b0ef6","225":"f87bc2b6","481":"69b0b171","486":"7132834c","770":"07fe5ce1"}[chunkId] + ".0.07091915638687474.chunk.js";
};